module.exports = __webpack_public_path__ + "resources/img/img_xcloud.2003f703cc29013a7b795b56a27185e2.png";